import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import Card from '../components/Card';
import '../App.css';

const Space = () => {
  const pageAnimation = {
    initial: { opacity: 0, y: 80 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }
    }
  };

  const features = [
    {
      icon: '◉',
      title: 'Easy Integration',
      description: 'Simple SDK and API to integrate staking into your project in minutes'
    },
    {
      icon: '◈',
      title: 'Secure & Audited',
      description: 'Smart contracts audited by leading security firms'
    },
    {
      icon: '◆',
      title: 'Flexible Rewards',
      description: 'Customize reward rates, lock periods, and distribution methods'
    },
    {
      icon: '▣',
      title: 'Analytics Dashboard',
      description: 'Real-time metrics and insights for your staking pool'
    },
    {
      icon: '◇',
      title: 'Low Fees',
      description: 'Competitive pricing with transparent fee structure'
    },
    {
      icon: '⬢',
      title: 'Full Support',
      description: 'Technical support and documentation for smooth integration'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Little Rabbit Space</title>
        <link rel="icon" type="image/png" href="/favicon-round.png?v=4" />
        <link rel="shortcut icon" href="/favicon-round.png?v=4" />
      </Helmet>
      <motion.div 
        className="page-container"
        {...pageAnimation}
      >
      <motion.section
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.1 }}
      >
        <Card delay={0}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.3, type: 'spring' }}
              style={{ fontSize: '72px', marginBottom: '16px' }}
            >
              ◈
            </motion.div>
            <h1 style={{ fontSize: '36px', fontWeight: '900', marginBottom: '16px', color: '#fff' }}>
              Space Ecosystem
            </h1>
            <p style={{ fontSize: '18px', color: 'rgba(255,255,255,0.7)', maxWidth: '700px', margin: '0 auto', lineHeight: '1.6' }}>
              We are building a dApp tool that makes it easy for projects to deploy staking and dApps effortlessly. Space will become our integrated ecosystem on the LRST platform, enabling developers to focus on growing their projects.
            </p>
            <div style={{ marginTop: '24px', padding: '12px 24px', background: 'rgba(229, 9, 20, 0.15)', borderRadius: '12px', display: 'inline-block' }}>
              <span style={{ fontSize: '14px', fontWeight: '700', color: '#e50914' }}>◈ Coming Soon - Staking as a Service</span>
            </div>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
            gap: '20px',
            marginTop: '40px'
          }}>
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                whileHover={{ 
                  scale: 1.02, 
                  y: -4,
                  transition: { duration: 0.2 }
                }}
                style={{
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '16px',
                  padding: '24px',
                  textAlign: 'center',
                  cursor: 'pointer'
                }}
              >
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>
                  {feature.icon}
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: '800', marginBottom: '8px', color: '#fff' }}>
                  {feature.title}
                </h3>
                <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.5' }}>
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </Card>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        style={{ marginTop: '24px' }}
      >
        <Card delay={0}>
          <h2 style={{ fontSize: '28px', fontWeight: '900', marginBottom: '20px', color: '#fff' }}>
            Roadmap Staking as a Service
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              style={{ display: 'flex', gap: '16px', alignItems: 'start' }}
            >
              <div style={{
                minWidth: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #e50914, #ff4458)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                fontWeight: '900',
                color: '#fff'
              }}>
                1
              </div>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '800', marginBottom: '6px', color: '#fff' }}>
                  Platform Development
                </h3>
                <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.7)', lineHeight: '1.6' }}>
                  We are building the platform and tools for easy staking & dApp deployment.
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              style={{ display: 'flex', gap: '16px', alignItems: 'start' }}
            >
              <div style={{
                minWidth: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #e50914, #ff4458)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                fontWeight: '900',
                color: '#fff'
              }}>
                2
              </div>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '800', marginBottom: '6px', color: '#fff' }}>
                  Integration Testing
                </h3>
                <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.7)', lineHeight: '1.6' }}>
                  Beta testing with selected partners to ensure the platform runs optimally.
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              style={{ display: 'flex', gap: '16px', alignItems: 'start' }}
            >
              <div style={{
                minWidth: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #e50914, #ff4458)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                fontWeight: '900',
                color: '#fff'
              }}>
                3
              </div>
              <div>
                <h3 style={{ fontSize: '18px', fontWeight: '800', marginBottom: '6px', color: '#fff' }}>
                  Public Launch
                </h3>
                <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.7)', lineHeight: '1.6' }}>
                  Space ecosystem will be launched for all projects wanting to deploy staking & dApps.
                </p>
              </div>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            style={{ marginTop: '32px', textAlign: 'center' }}
          >
            <motion.a
              href="https://t.me/littlerabbitchat"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.98 }}
              style={{
                display: 'inline-block',
                padding: '16px 48px',
                borderRadius: '999px',
                background: 'linear-gradient(135deg, #e50914, #ff4458)',
                color: '#fff',
                fontSize: '16px',
                fontWeight: '900',
                textDecoration: 'none',
                boxShadow: '0 8px 24px rgba(229, 9, 20, 0.4)',
                cursor: 'pointer'
              }}
            >
              Join Community →
            </motion.a>
          </motion.div>
        </Card>
      </motion.section>
    </motion.div>
    </>
  );
};

export default Space;
